var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8.75H9.75V1.25C9.75 1.05109 9.67098 0.860322 9.53033 0.71967C9.38968 0.579018 9.19891 0.5 9 0.5V0.5C8.80109 0.5 8.61032 0.579018 8.46967 0.71967C8.32902 0.860322 8.25 1.05109 8.25 1.25V8.75H0.75C0.551088 8.75 0.360322 8.82902 0.21967 8.96967C0.0790176 9.11032 0 9.30109 0 9.5H0C0 9.69891 0.0790176 9.88968 0.21967 10.0303C0.360322 10.171 0.551088 10.25 0.75 10.25H8.25V17.75C8.25 17.9489 8.32902 18.1397 8.46967 18.2803C8.61032 18.421 8.80109 18.5 9 18.5C9.19891 18.5 9.38968 18.421 9.53033 18.2803C9.67098 18.1397 9.75 17.9489 9.75 17.75V10.25H17.25C17.4489 10.25 17.6397 10.171 17.7803 10.0303C17.921 9.88968 18 9.69891 18 9.5C18 9.30109 17.921 9.11032 17.7803 8.96967C17.6397 8.82902 17.4489 8.75 17.25 8.75Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.057c1fc5c73bfd23d2134c4396508876.svg";
export { ForwardRef as ReactComponent };